<h2 mat-dialog-title class="mat-dialog-title--icons !flex items-center gap-2">
  <img class="google-icon" src="assets/img/icons/google-logo.svg" i18n-alt alt="Google logo" />
  <span i18n>Unlink Google Account</span>
</h2>
<mat-dialog-content>
  <div class="info-block">
    <p i18n>
      Success! You have unlinked your Google account from WISE. To sign in to WISE in the future,
      please use your username and the password you just created.
    </p>
    <p i18n>
      Your username is: <span class="mat-subtitle-2">{{ username }}</span
      >.
    </p>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close i18n>Done</button>
</mat-dialog-actions>
